exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-request-modal {\n  max-width: 540px;\n}\n", ""]);

// exports
